<template>
  <div>
    <Tabs :value="value">
      <!-- <TabPane label="展厅项目案例" name="name1">
        <ThreeDimensional></ThreeDimensional>
      </TabPane> -->
      <TabPane label="智能设备展示区" name="name2">
        <Interaction></Interaction>
      </TabPane>
      <TabPane label="VR虚拟现实" name="name3">
        <Row justify="start" type="flex">
          <Col
            class="buy_col01"
            v-for="(item, index) in photoArr1"
            :key="index"
          >
            <div class="buy_rule" @click="getMoney(item)">
              <img :src="item.photoUrl" alt="#" />
            </div>
            <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
            <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
              <!--{{item.money}}-->
              <Button type="primary" @click="getMoney(item)">了解更多</Button>
            </div>
          </Col>
        </Row>
      </TabPane>
      <TabPane label="AR增强现实" name="name4">
        <AR></AR>
      </TabPane>
      <TabPane label="MR混合现实" name="name5">
        <MR></MR>
      </TabPane>
    </Tabs>

    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="850px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ item01.ref }}</span>
            </Col>
            <Col span="3"> </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <!-- <div class="">
              价 格: <span style="color: #1966ff"> {{ item01.money }}</span>
            </div> -->
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import AR from "./AR.vue";
import MR from "./MR.vue";
// import ThreeDimensional from "./ThreeDimensional.vue";
import Interaction from "./Interaction.vue";
export default {
  components: {
    AR,
    MR,
    Interaction,
    // ThreeDimensional,
  },
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      profile: "",
      VRImg: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_yb.jpg",
          p: "参照实际样板搭建场景，所有样板均融入交互式体验，使施工人员对工程质量交底的了解更充分彻底。 建设工程质量关系到群众的切实利益与施工企业的生命。要保证工程施工质量，增强质量责任意识，要从施工过程的各个环节方面落实责任，全面推行质量保证体系。",
          ref: "VR质量样板",
          money: "",
        },
        {
          photoUrl: "../../../static/img/photo/photo_3d.jpg",
          p:
            "使用VR技术身临其境公共安全体验火灾的危险环境，VR系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高火灾突发时的逃生技能",
          ref: "3D视频动画定制教育软件",
          money: "¥500.00-￥4000.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_quake.jpg",
          p:
            "学进入交互式场景体验，通过系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高学生在火灾突发时的逃生技能",
          ref: "VR地震事故体验定制软件",
          money: "¥500.00-￥2000.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_traffic.jpg",
          p:
            "学校是培养二十一世纪人才的摇篮，学生是祖国的未来和民族的希望；由于社会各界十分重视学校的安全工作，安全事故的发生率也在明显的下降，、" +
            "但是安全事故还时有发生，很大一部分原因与小学生的活动精力旺盛和自我保护能力有限有关。VR校园安全体验系统的出现，大大增强了师生安全意识，让学生“亲身”体验安全事故的场景，从而增强人身保护意识，减少悲剧的发生。",
          ref: "VR校园事故安全体验馆动画定制",
          money: "¥300.00-￥7400.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_electric.jpg",
          p:
            "通过VR表现，整个工程逼真的展现在眼前，体验者可以在虚拟中身临其境感受到施工过程中的各种危险和伤害，提高施工人员的安全" +
            "课程培训的兴趣和积极性",
          ref: "VR房建事故体验馆定制教育软件",
          money: "￥300.00-￥8000.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_student.jpg",
          ref: "学校款VR消防安全普及推广体验",
          p:
            "相对于我们的标准版VR消防安全知识普及而言，南秀学校定制版VR消防安全更具有对学生的针对性，抓住青少年及未进入社会的学生视角的痛点， " +
            "南秀科技在学校定制版安全普及中加入关于校园霸凌问题、青少年性侵、针对学生的校园诈骗校园传销和暑期青少年溺水等时下尚未得到良好解决办法的社会关注的问题。",
          money: "¥5000.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_subway.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。",
          ref: "起重机伤害VR虚拟体验",
          money: "¥500.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_fire.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。" +
            "使用VR技术身临其境公共安全体验火灾的危险环境，VR系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高火灾突发时的逃生技能",
          ref: "火灾伤害VR虚拟体验",
          money: "¥500.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_first-aid.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。" +
            "使用VR技术身临其境的体验现场急救的VR虚拟体验，针对正常施工现场人员心脏骤停(如触电、高空作业、心脏疾病、" +
            "心肌梗塞、自然灾害、意外事故等所造成的心脏骤停)等紧急情况，现场体验如何进行气道开放、胸外按压、人工口鼻呼吸、体外除颤等抢救过程，" +
            "使病人在短时间内得到救护。",
          ref: "现场急救VR虚拟体验",
          money: "¥500.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_drop.jpg",
          p:
            "生产生活中，尽管采取了各种防范措施，但人身事故仍时有发生，不仅影响到生产生活的正常进行，也带来企业品牌及社会的负面效应，" +
            "同时给当事人及家庭带来沉重的灾难，影响社会团结稳定。\n" +
            "通过VR仿真模拟，让员工身临其境感受事故发生经过，从而在内心深处对事故产生敬畏心理，树立安全第一的思想意识。",
          ref: "施工电梯坠落事故VR虚拟体验",
          money: "¥300.00",
        },
        {
          photoUrl: "../../../static/img/photo/photo_slip.jpg",
          p:
            "相比于传统的工地体验区，VR技术下的虚拟VR体验馆更具有优势：VR安全体验区比实体体验区能够展现更多的体验场景，比如从几十层高的洞口坠落、高空安全带错误使用导致坠落的场景等，同时，VR 场景更加真实完整，体验感更强，安全教育效果更明显。\n" +
            "通过模拟工地建筑施工中的洞口、电梯井等真实场景，开口处维护缺失，工人带上VR眼睛，从视觉上体验从上百米的高度做自由落体运动；同时可以模拟安全带正确使用，高出坠落时身体悬挂在空中等事故。",
          ref: "临边失足坠落事故VR虚拟体验",
          money: "¥500.00",
        },
      ],
      value: "name2",
    };
  },
  mounted() {
    console.log(this.$route.query.id);

    if (this.$route.query.id == 3) {
      this.value = "name2";
    } else if (this.$route.query.id == 4) {
      this.value = "name3";
    }
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
      this.VRImg = item.VRImg;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 10px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 263px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: 15px;
}

.buy_rule img:hover {
  animation: move 0.5s linear forwards;
}

@keyframes move {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/VR.vue